import { useCallback, useEffect, useRef, useState } from "react";
import { globalSearch } from "@ludens-reklame/rubics-v3-sdk/search";
export function useSearch(fetcher, init = {}, query) {
    const [loading, setLoading] = useState(false);
    const [hasFetched, setHasFetched] = useState(false);
    const [hasMore, setHasMore] = useState(false);
    const [results, setResults] = useState([]);
    const [facets, setFacets] = useState([]);
    const [usedQuery, setUsedQuery] = useState({});
    const totalResultsRef = useRef(0);
    const queryRef = useRef({});
    const search = useCallback(async (paginate, _query) => {
        let usedQuery = { ...(query || {}), ...(_query || {}) };
        if (paginate) {
            if (!_query) {
                usedQuery = queryRef.current;
            }
            usedQuery.skip = totalResultsRef.current;
            // We don't fetch new facets when paginating, as they don't change
            if (query?.faceted) {
                usedQuery.faceted = false;
            }
        }
        setLoading(true);
        const response = await fetcher(usedQuery);
        setResults((results) => paginate ? [...results, ...response.results] : response.results);
        if (paginate) {
            totalResultsRef.current += response.results.length;
        }
        else {
            totalResultsRef.current = response.results.length;
        }
        if (!paginate) {
            setFacets(response.facets);
        }
        setHasFetched(true);
        setUsedQuery(usedQuery);
        setLoading(false);
        queryRef.current = usedQuery;
        if (response.results.length < (usedQuery?.limit || 20)) {
            setHasMore(false);
        }
        else {
            setHasMore(true);
        }
    }, 
    // I want to add query to the dependencies, but since it's an object react can't diff it properly
    [fetcher]);
    useEffect(() => {
        if (init.fetchOnInit) {
            search();
        }
    }, [init.fetchOnInit]);
    return {
        loading,
        hasFetched,
        hasMore,
        results,
        facets,
        usedQuery,
        search,
    };
}
export function useGlobalSearch(query) {
    const [loading, setLoading] = useState(false);
    const [results, setResults] = useState([]);
    const search = useCallback(async () => {
        if (!query) {
            return;
        }
        setLoading(true);
        const results = await globalSearch(query);
        setResults(results);
        setLoading(false);
    }, [query]);
    useEffect(() => {
        search();
    }, [search]);
    return {
        results,
        loading,
    };
}
